import Image from "next/image";
import Link from "next/link";
import bgImage from "../../public/images/bg/bg-image-10.jpg";
import { DateTime } from 'luxon';

const BlogBreadCrumb = ({ blogType, matchedBlog, categoryName, categoryPath }) => {

  const formattedBlogDate = DateTime.fromISO(matchedBlog.date.published)
    .setLocale('en-US')
    .toLocaleString(DateTime.DATE_FULL);

  return (
    <>
      <div className="breadcrumb-image-container breadcrumb-style-max-width">
        <div className="breadcrumb-image-wrapper">
          <Image src={bgImage} alt="Education Images" />
        </div>
        <div className="breadcrumb-content-top text-center">
          <ul className="meta-list justify-content-center mb--10">
            <li className="list-item">
              <div className="author-thumbnail">
                {matchedBlog && (
                  <Image
                    src={matchedBlog.author[0].img}
                    width={494}
                    height={494}
                    alt="blog-image"
                  />
                )}
              </div>
              {matchedBlog && (
                <div className="author-info">
                  <Link href="#">
                    <strong>{matchedBlog.author[0].name}</strong>
                  </Link>{" "}
                  in{" "}
                  <Link href={categoryPath}>
                    <strong>{categoryName}</strong>
                  </Link>
                </div>
              )}
            </li>
            {matchedBlog && (
              <li className="list-item">
                <i className="feather-clock"></i>
                {/* <span>{matchedBlog.date.published}</span> */}
                <span>{formattedBlogDate}</span>
              </li>
            )}
          </ul>
          {matchedBlog && <h1 className="title">{matchedBlog.title}</h1>}
          {matchedBlog.description && <p>{matchedBlog.description.short}</p>}
        </div>
      </div>
    </>
  );
};

export default BlogBreadCrumb;
